import { useEffect, useRef } from "react";

const SCRIPT_SRC = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
let scriptPromise = null;

function loadTurnstile() {
  if (window.turnstile) return Promise.resolve(window.turnstile);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const existing = document.querySelector(`script[src="${SCRIPT_SRC}"]`);
      const script = existing || document.createElement("script");
      script.async = true;
      script.src = SCRIPT_SRC;
      script.onload = () => resolve(window.turnstile);
      script.onerror = () => reject(new Error("turnstile"));
      if (!existing) document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

export const TurnstileField = ({ resetKey, onToken, error }) => {
  const siteKey = process.env.REACT_APP_TURNSTILE_SITE_KEY || "";
  const holder = useRef(null);
  const onTokenRef = useRef(onToken);
  onTokenRef.current = onToken;

  useEffect(() => {
    if (!siteKey || !holder.current) return undefined;
    let widgetId = null;
    let cancelled = false;
    loadTurnstile()
      .then((turnstile) => {
        if (cancelled || !holder.current) return;
        widgetId = turnstile.render(holder.current, {
          sitekey: siteKey,
          callback: (token) => onTokenRef.current(token || ""),
          "expired-callback": () => onTokenRef.current(""),
          "error-callback": () => onTokenRef.current(""),
        });
      })
      .catch(() => onTokenRef.current(""));
    return () => {
      cancelled = true;
      if (widgetId != null && window.turnstile) window.turnstile.remove(widgetId);
    };
  }, [siteKey, resetKey]);

  if (!siteKey) {
    return (
      <p className="text-xs text-amber-800" role="alert" data-testid="captcha-unconfigured">
        The security check is not set up yet. Nothing can be sent until it is.
      </p>
    );
  }

  return (
    <div>
      <div ref={holder} data-testid="captcha-widget" />
      {error && (
        <p className="mt-1 text-xs text-red-600" role="alert" data-testid="captcha-error">
          {error}
        </p>
      )}
    </div>
  );
};
